import React, { useContext } from "react";
import CourseContext from "../../context/CourseContext";
import Button from "./Button";
import { useLanguage } from "../../context/LanguageContext";

const SectionableOpenLink = ({ sectionable, section, type }) => {
    const { language } = useLanguage();
    const translations = {
        ar: {
            video: "مشاهدة الفيديو",
            book: "فتح الملف",
            hm: "فتح الواجب",
            course_link: "فتح",
            exam: "بدء الامتحان",
            zoom_live: "فتح اللايف",
        },
        en: {
            video: "Watch Video",
            book: "Open File",
            hm: "Open Homework",
            course_link: "Open",
            exam: "Start Exam",
            zoom_live: "Join Live",
        },
        de: {
            video: "Video ansehen",
            book: "Datei öffnen",
            hm: "Hausaufgabe öffnen",
            course_link: "Öffnen",
            exam: "Prüfung starten",
            zoom_live: "Live beitreten",
        },
    };
    let color = "yellow";
    let text = "مشاهدة الفيديو";
    if (type === "book") {
        color = "blue";
        text = "فتح الملف";
    } else if (type === "hm") {
        color = "teal";
        text = "فتح الواجب";
        type = "exam";
    } else if (type === "course_link") {
        color = "indigo";
        text = "فتح";
    } else if (type === "exam") {
        color = "rose";
        text = "بدا الامتحان";
        type = "exam";
    } else if (type === "zoom_live") {
        color = "yellow";
        text = "فتح اللايف";
    }

    const { course, isRefresh } = useContext(CourseContext);

    let element = "Link";
    let props = { to: `sections/${section.id}/${type}/${sectionable.id}` };
    if (isRefresh && type === "video" && sectionable.sectionable.platform === "ink") {
        element = "a";
        props = { href: `/course/${course.id}/sections/${section.id}/${type}/${sectionable.id}` };
    }
    return (
        <Button className="font-smaller" color={color} element={element} {...props}>
            {translations[language][type]}
        </Button>
    );
};

export default SectionableOpenLink;
